// extracted by mini-css-extract-plugin
export default {"button":"button_button__zbfSX","wrapper":"button_wrapper__oGQZj","counter":"button_counter__4eipL"};